/* eslint-disable import/newline-after-import */
/* istanbul ignore file */

import 'regenerator-runtime/runtime';
import config from 'config';
import queryString from 'query-string';
import { polyfill } from 'mobile-drag-drop';
import { polyfillElementClosest } from './services/PolyfillService';
import { configureErrorLogging } from './services/ErrorReporting';
import storeManager from './store/StoreManager';
import dataLoader from './loading/dataLoader';
import dynamicDataLoader from './loading/dynamicDataLoader';
import i18nService from './services/i18nService';
import sessionParameterService from './services/sessionParameters/SessionParameterService';
import sessionReader from './store/readHelpers/SessionReader';
import renderingService from './services/RenderingService';
import uiService from './services/UIService';
import chromeAppService from './services/ChromeAppService';
import marketplaceSettingsService from './services/MarketplaceSettingsService';
import { writeInlineMathJaxConfigScript } from './components/question/mathDisplay/MathJax2Display';
import environmentNames from './environmentNames';
import globalsService from './services/GlobalsService';
import pendoAnalyticsService from './services/PendoAnalyticsService';

/* eslint-disable no-undef, camelcase */
// Setting `__webpack_public_path__` to handle lazy module loading
// This will set correct path to get this module
__webpack_public_path__ = process.env.NODE_ENV === environmentNames.DEBUG ?
    'http://localhost:8090/' :
    `${globalsService.getAssetRoot()}/`;
/* eslint-enable no-undef, camelcase */

require('./styles/base.scss');
require('../node_modules/font-awesome/scss/font-awesome.scss');
require('../node_modules/literallycanvas/scss/literallycanvas.scss');
window.Promise = require('bluebird');
Promise.config({
    warnings: false,
});

writeInlineMathJaxConfigScript();

polyfill();
polyfillElementClosest(window);

marketplaceSettingsService.setMarketplace(window.marketplaceName);

// The store is used everywhere, so initialize it before doing anything else.
const store = storeManager.configureAndSetStore({});
window.InsperaPlayer = { storeManager, dynamicDataLoader };

const params = queryString.parse(location.search);
sessionParameterService.setSessionParams(Object.assign({}, params, { enableHypothesis: params.enableHypothesis === 'true' }));
configureErrorLogging();
chromeAppService.listenToInitEventFromApp();

uiService.setDirection(sessionReader.getLanguage());
uiService.setCurrentMarketplaceTheme();

/* eslint-disable no-unused-vars */
window.establishFunctionBridge = function establishFunctionBridge(callbacks) {
    window.bridgeCallbacks = callbacks;
};

renderingService.renderApp(store);
renderingService.configureAppRootForModal();

if (!window.playerStartupConfig || !window.playerStartupConfig.shouldUseNewLoader) {
    const preloaderImage = document.getElementById('loader-img');
    if (preloaderImage) {
        preloaderImage.style.display = 'none';
    }
}

dataLoader.initDataLoading();
i18nService.initI18n(sessionReader.getLanguage());

const preventDefaultsKeyboardEventsForGradingNavigation = (event) => {
    const key = event.keyCode;
    const hotKeys = [37, 38, 39, 40];
    if (event.altKey && hotKeys.includes(key)) {
        event.preventDefault();
        window.blur();
    }
};

if (params.gradingKeyboardNavigationSupport) {
    window.removeEventListener('keydown', preventDefaultsKeyboardEventsForGradingNavigation);
    window.addEventListener('keydown', preventDefaultsKeyboardEventsForGradingNavigation);
}

if (config.debugRendering) {
    // const registerObserver = require('react-perf-devtool');
    // registerObserver();
}

pendoAnalyticsService.initializePendo({
    onSuccess: console.log,
    onFailure: console.warn,
});
